import React from 'react';

const imgMap = require('@app/content/LOV_map.png');
const line = require('@app/images/highlight_text_dark.svg');

const BlockWithMap: React.FC = () => {
	return (
		<section className="block-map">
			<div className="block-map-wrap">
				<div className="block-map-wrap__text">
					<h3>The Industry Leader in End-of-Life Veterinary Care</h3>
					<p>
						Lap of Love has helped thousands of clinics across the country relieve the stress that euthanasia appointments can bring. We
						build strong relationships with veterinarians and their teams by providing information and education and by serving as a
						trusted resource and partner to turn to for your families in need of end-of-life care for their pets.
					</p>
					<ul>
						<li>Assisted over 500,000 pets and families</li>
						<li>Over 300 veterinarians across the US in 35 states</li>
						<li>Dedicated phone center support</li>
						<li>In-home euthanasia, pet hospice, telehospice, and pet loss support services available</li>
						<li>Delivered over 1K hours of educational speaking in the industry</li>
					</ul>
				</div>
				<div className="block-map-wrap__img">
					<img src={imgMap} alt="map" />
				</div>
			</div>
			<img src={line} alt="line" className="line" />
		</section>
	);
};

export default BlockWithMap;
